<template>
    <div>
        <Row :gutter="4" style="margin-bottom: 10px;">
            <Col span="6">
                <DatePicker type="daterange" v-model="startAndEndTime" @on-change="searchTime($event)" placement="bottom-end" :placeholder="$t('Bill.CostAllocation.timer')" style="width: 100%" :transfer="true"></DatePicker>
            </Col>
            <Col span="6">
                <Button type="warning" @click="downloadModal = true" :disabled="isConfirmation">{{ $t("BillingServices.export") }}</Button>
            </Col>
        </Row>
        <Table ref="selection" :columns="columns" :data="tableCostAllocationDate" style="width: 100.1%;" @on-selection-change="getSelection">
            <template slot-scope="{row,index}" slot="action">
                <Button type="primary" size="small" @click="addOrUpdateHandle(row.id)">{{ $t("alarms.common.edit") }}</Button>
                <span @click="doDelete(index)">
                    <Button type="error" size="small" @click="costAllocationModal = true">{{ $t('BillingServices.del') }}</Button>
                </span>
            </template>
        </Table>
        <!-- 批量导出模式框 -->
        <Modal v-model="downloadModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#ff9900;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('Bill.CostAllocation.batchExport') }}</span>
            </p>
            <div style="text-align:center">
                <p>你确定要批量导出以下数据吗?</p>
            </div>
            <div slot="footer">
                <Button type="warning" size="large" long :loading="loading" @click="downloadFile()">{{ $t("BillingServices.export") }}</Button>
            </div>
        </Modal>
        <!-- 删除模式框 -->
        <Modal v-model="costAllocationModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>删除确认</span>
            </p>
            <div style="text-align:center">
                <p>你确认要删除 {{deleteName}} 吗?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="modal_loading" @click="removeCostAllocation()" :disabled="isDisable">{{ $t('BillingServices.del') }}</Button>
            </div>
        </Modal>
        <!-- 分页 -->
        <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>
        <!-- 弹窗，新增/编辑 -->
        <add-or-update-cost-allocation v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-cost-allocation>
    </div>
</template>
<script>
    import AddOrUpdateCostAllocation from '../cost_allocation/AddOrUpdateCostAllocation'
    var tableCostAllocationVue = {};
    export default {
        name: 'TableCostAllocation',
        components: {
            AddOrUpdateCostAllocation
        },
        data () {
            return {
                startAndEndTime:[],
                loading:false,
                downloadModal: false,
                isConfirmation: true,
                addOrUpdateVisible:false,
                current:1,
                dataTotal:0,
                pageSize:10,
                deleteName:'',
                costAllocationModal:false,
                isDisable: false,
                modal_loading: false,
                columns: [
                {
                    width: 50,
                    titleAlign: 'center',
                    columnAlign: 'center',
                    type: 'selection'
                },
                {
                    title: "表名",
                    key: "tableName"
                },
                {
                    title: "应用名",
                    key: "applicationName"
                },
                {
                    title: "Cost Center",
                    key: "describe"
                },
                {
                    title: "操作",
                    slot: 'action'
                }],
                tableCostAllocationDate:[],
                costCenterIdList:[]
            }
        },
        beforeCreate: function() {
            tableCostAllocationVue = this
        },
        mounted: function(){
            tableCostAllocationVue.getData();
        },
        methods: {
            init:function(){
                if (this.startAndEndTime[0]!='') {
                    this.isConfirmation = false;
                } else {
                    this.isConfirmation = true;
                }
            },
            showAll: function(){
                tableCostAllocationVue.getData();
            },
            // 查询时间
            searchTime: function($event){
                this.startAndEndTime=$event;
                // 选了数据可以点编辑
                this.init();
            },
            // 分页显示数据
            /****************************************************/
            getData:function() {
                //分页
                this.$api.apportion.page({
                    "pageNum": this.$route.query.pageNum!= undefined ? this.$route.query.pageNum : this.current,
                    "pageSize": this.$route.query.pageSize!= undefined ? this.$route.query.pageSize : this.pageSize
                })
                .then(res => {
                    this.tableCostAllocationDate = res.data.records;
                    // 当前页
                    this.current = res.data.current;
                    // 总条数
                    this.dataTotal = res.data.total;
                });
            },
            changePage: function(current){
                this.$router.push({query: {}});
                this.current=current;
                tableCostAllocationVue.getData();
            },
            changeSize: function(pageSize){
                this.$router.push({query: {}});
                this.pageSize=pageSize;
                tableCostAllocationVue.getData();
            },
            // 删除
            /****************************************************/
            doDelete: function(index){
                this.lineIndex=index;
                this.deleteName=this.tableCostAllocationDate[index].tableName;
            },
            removeCostAllocation: function(){
                this.isDisable = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //删除
                this.$api.apportion.delete("id",this.tableCostAllocationDate[lineIndex].id)
                .then(res => {
                    this.modal_loading = true;
                    setTimeout(() => {
                        if(lineIndex === 0 && ((this.current - 1) * this.pageSize + 1) === this.dataTotal && this.current > 1){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        tableCostAllocationVue.getData();
                        this.isDisable = false;
                        this.modal_loading = false;
                        this.costAllocationModal = false;
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            },
            // 编辑
            /**********************************************************************************/
            addOrUpdateHandle:function(id){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$router.push({path:'/ebilling/addOrUpdateCostAllocation/',query:{pageNum: this.current,pageSize: this.pageSize,id:id}});
                })
            },
            // 批量导出
            /********************************************************/
            // 多选
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.costCenterIdList = [];
                for (let i = 0; i < this.selection.length; i++) {
                    this.costCenterIdList.push(this.selection[i].id);
                }
            },
            downloadFile: function () {
                //导出
                this.loading = true
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.apportion.exportExcel({
                    "time":this.startAndEndTime,
                    "apportionIdList":this.costCenterIdList
                })
                .then(res => {
                    let fileName = '成本分摊.xlsx'
                    let blob = new Blob([res.data], {type: 'application/x-xlsx'})
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                    }
                    tableCostAllocationVue.getData();
                    this.loading = false;
                    this.downloadModal=false;
                    this.isConfirmation = true;
                    this.startAndEndTime=[];
                    this.costCenterIdList=[];
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ebilling/cost_allocation/TableCostAllocation.vue